import { useMemo } from "react";

// Assets
import IDot from "assets/i-dot.js";
import IPin from "assets/i-pin.js";
import IInfo from "assets/i-info.js";
import IRefresh from "assets/i-refresh.js";
import IArrowShortail from "assets/i-arrow-shortail.js";
import ISofia from "assets/i-sofia";
import IFile from "assets/i-file";

import ModalDetailListing from "components/molecules/buyer-match/modal-detail-listing";
import Button from "components/v1/Button";

const FEAT = ({ val, lastItem, isSquare }) => {
  return (
    <>
      <span className="text-[11px] tracking-[-0.4px] leading-[18.571px] px-2 py-0.5 whitespace-nowrap font-inter text-[#808285]">
        {val}{" "}
        {isSquare && (
          <span>
            m<sup>2</sup>
          </span>
        )}
      </span>
      {!lastItem && <IDot width="8" height="8" />}
    </>
  );
};

const CardListing = ({ onTidiedUpPhoto, data, onOpenDetail, hideIconRapikan = false }) => {
  const DATA_FEAT = useMemo(() => {
    const res = [];

    if (data?.bathroom)
      res.push({
        value: data?.bathroom,
        label: "Kamar Mandi",
        isSquare: false,
      });

    if (data?.bedroom)
      res.push({
        value: data?.bedroom,
        label: "Kamar Tidur",
        isSquare: false,
      });

    if (data?.surface_area)
      res.push({
        value: data?.surface_area,
        label: "Luas Area",
        isSquare: true,
      });

    if (data?.building_area)
      res.push({
        value: data?.building_area,
        label: "Luas Bangunan",
        isSquare: true,
      });

    return res;
  }, [data]);

  return (
    <div className="py-[12px] px-4 flex items-center gap-[12px] border-b-[0.5px] border-solid border-[#D8D8D9] last:border-b-0">
      <div className="w-[100px] aspect-square rounded-[8px]">
        <img
          src={data?.cover_url || ""}
          alt={data?.title || "Property"}
          className="w-full h-full object-cover rounded-[8px]"
        />
      </div>

      <div className="w-full">
        <div className="flex justify-between items-end w-full border-b-[0.5px] border-dashed border-[#DEDFDE] pb-0.5 mb-0.5">
          <div className="flex flex-col gap-[4px] w-full">
            <p className="flex items-center gap-1 text-[13px] tracking-[-0.4px] leading-[21px] font-inter text-[#252526]">
              <IPin /> {data?.area}, {data?.city}
            </p>
            <p className="text-[13px] tracking-[-0.4px] leading-[21px] font-inter text-[#252526]">
              Rp{data?.price?.toLocaleString("id-ID")}
            </p>
            <p className="text-[11px] tracking-[-0.4px] leading-[18.571px] font-inter text-[#808285]">
              {data?.title}
            </p>
          </div>

          <div className="flex flex-col gap-2 justify-end items-end w-full">
            <div className="flex items-center gap-2">
              <Button
                className="!w-8 !h-8 !p-[10px]"
                type="secondary"
                size="s"
                icon={IInfo}
                onClick={onOpenDetail}
              />
              {data?.is_draft ? (
                <Button
                  type="primary"
                  size="s"
                  text="Lanjutkan Perapihan"
                  iconPosition="right"
                  icon={IRefresh}
                  iconColor="#FFFFFF"
                  onClick={onTidiedUpPhoto}
                />
              ) : (
                <Button
                  type="primary"
                  size="s"
                  text="Pilih Listing"
                  iconPosition="right"
                  icon={IArrowShortail}
                  iconColor="#FFFFFF"
                  rotateIcon="180"
                  onClick={onTidiedUpPhoto}
                />
              )}
            </div>
            {!!DATA_FEAT?.length && (
              <div className="flex items-center justify-end gap-1 rounded-[2px] bg-[#F5F5F5] px-1 h-[18px]">
                {DATA_FEAT?.map((item, index) => (
                  <FEAT
                    key={`item-data-faeture-${index}`}
                    val={`${item.label}: ${item.value}`}
                    lastItem={index === DATA_FEAT?.length - 1}
                    isSquare={item.isSquare}
                  />
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2">
          <p className="text-[11px] tracking-[-0.4px] leading-[18.571px] w-full font-inter text-[#808285] w-fit">
            Dibuat <span className="font-semibold">{data?.user_fullname}</span>
          </p>
          {(data?.is_tidied_up_by_sofia && !hideIconRapikan) && (
            <>
              <IDot />
              <p className="text-[11px] tracking-[-0.4px] leading-[18.571px] w-full font-inter text-[#808285] flex items-center gap-1 w-fit">
                <ISofia /> Dirapikan{" "}
                <span className="font-inter-bold">Sofia</span>
              </p>
            </>
          )}
          {data?.is_draft && (
            <>
              <IDot />
              <p className="bg-[#EBF0F7] px-[0.5px] py-0.5 text-[11px] tracking-[-0.4px] leading-[18.571px] w-full font-inter text-[#808285] flex items-center gap-1 w-fit">
                <IFile /> Draft
              </p>
            </>
          )}
        </div>
      </div>

      <ModalDetailListing
        isOpen={false}
        onClose={() => {}}
        slug={""}
        onSendListing={() => {}}
        property_images={[]}
        propertyId={""}
      />
    </div>
  );
};

export default CardListing;
